<template>
  <NavbarOne />
  <PageBanner
    pageTitle="سياسة الخصوصية"
    subTitle="تعرف على كيفية جمع واستخدام وحماية بياناتك الشخصية عند استخدام خدمات وموقع IPTV الخاص بنا."
    :pageBannerImage="pageBannerImg"
  />
  <PrivacyPolicy />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import PrivacyPolicy from "@/components/PrivacyPolicy/index.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "PrivacyPolicyPage",
  components: {
    NavbarOne,
    PageBanner,
    PrivacyPolicy,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "سياسة الخصوصية | حماية بيانات المستخدم",
      meta: [
        {
          name: "description",
          content:
            "اطلع على سياسة الخصوصية الخاصة بموقعنا، وكيفية جمع المعلومات الشخصية واستخدامها وحمايتها عند الاستفادة من خدمات اشتراكات IPTV.",
        },
        {
          name: "keywords",
          content:
            "سياسة الخصوصية, حماية البيانات, خصوصية المستخدم, IPTV, بيانات المستخدم",
        },
        {
          property: "og:title",
          content: "سياسة الخصوصية | حماية بيانات المستخدم",
        },
        {
          property: "og:description",
          content:
            "تعرف على كيفية حماية بياناتك الشخصية وآلية التعامل معها عند استخدام خدماتنا.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/privacy-policy",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-5.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>